/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, createRef, useState, useMemo, useRef } from "react";
import { usePageApiQueue } from "../../Components/Hooks/PageApiQueue";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
} from "reactstrap";
import {
  currencyFormatWithAlert,
  currencyFormatWithoutDecimal,
  numberFormat,
} from "../../helpers/api_helper";
import Loader from "../../Components/Common/Loader";
import { getDateByName } from "../../helpers/api_helper";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { POST_KPI_DASHBOARD } from "../../helpers/data_helper";
import CustomPagination from "../../Components/Common/CustomPagination";
import ServerModal from "./ServerModal";

const itemsPerPage = 1000;
let sorttypefinalvalue;

const ServerPerformance = ({
  mealPeriod,
  activeDate,
  customDate,
  server_id,
  recalculate,
  showGraph,
  currency,
}) => {
  const [selectedPage, setSelectedPage] = useState(0);
  const [serverPerformances, setServerPerformances] = useState([]);
  const [serverPerformanceAjax, setServerPerformanceAjax] = useState(true);
  const [selectedServers, setSelectedServers] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  useEffect(() => {
  }, [showDetailsModal]);

  const { enqueue } = usePageApiQueue();
  const controllerRef = useRef(null);

  useEffect(() => {
    if (
      activeDate.value !== "Custom" ||
      (activeDate.value === "Custom" && customDate[0] && customDate[1])
    ) {
      setServerPerformanceAjax(true);
      return handleSort(sortColumn, "initial");
    }
  }, [selectedPage, recalculate, activeDate, customDate, mealPeriod]);

  const [sortColumn, SetSortColumn] = useState("");
  const [selectedPageST, setSelectedPageST] = useState(0);

  const columnDef = [
    {
      name: "Server Name",
      key: "name",
      sort: true,
      className: "text-start",
    },
    {
      name: "Checks",
      key: "check_count",
      sort: true,
    },
    {
      name: "Covers",
      key: "covers",
      sort: true,
    },
    {
      name: "Revenue",
      key: "revenue",
      sort: true,
    },
    {
      name: "Avg. Check",
      key: "avgCheck",
    },
    {
      name: "vs Team Average",
      key: "teamAvg",
    },
    {
      name: "Cover %",
      key: "cover_percentage",
    },
    {
      name: "Check%",
      key: "check_percentage",
    },
    {
      name: "Revenue %",
      key: "revenue_percentage",
    },
    {
      name: "ACI",
      key: "aci",
    },
    {
      name: "Lost Opportunity",
      key: "lost_opportunity",
    },
  ];

  const [showColumns, setShowColumns] = useState(
    columnDef.map((column) => column.key)
  );

  const [isOpen, setIsOpen] = useState(false);
  const columnDropdownRef = createRef();

  const toggleDropdown = (e) => {
    if (columnDropdownRef.current.contains(e.target)) return;

    setIsOpen(!isOpen);
  };

  const handleColumnHideShow = (event, columnName) => {
    event.stopPropagation();

    if (showColumns.includes(columnName)) {
      setShowColumns(showColumns.filter((column) => column != columnName));
    } else {
      setShowColumns([...showColumns, columnName]);
    }

    console.log(event.target.value);
  };

  const handleSort = (value, callfrom) => {
    if (callfrom === "initial") {
      sorttypefinalvalue = localStorage.getItem("Server_Perf_SortType");
    } else {
      if (sortColumn != value) {
        localStorage.setItem("Server_Perf_SortType", "DESC");
        sorttypefinalvalue = "DESC";
      } else {
        if (localStorage.getItem("Server_Perf_SortType") === "") {
          localStorage.setItem("Server_Perf_SortType", "ASC");
          sorttypefinalvalue = "ASC";
        } else {
          if (localStorage.getItem("Server_Perf_SortType") === "ASC") {
            localStorage.setItem("Server_Perf_SortType", "DESC");
            sorttypefinalvalue = "DESC";
          } else {
            localStorage.setItem("Server_Perf_SortType", "ASC");
            sorttypefinalvalue = "ASC";
          }
        }
      }
    }

    SetSortColumn(value);

    var originalDate = new Date(customDate[0]);

    var year = originalDate.getFullYear();
    var month = (originalDate.getMonth() + 1).toString().padStart(2, "0");
    var day = originalDate.getDate().toString().padStart(2, "0");

    var datefrom = year + "-" + month + "-" + day;

    var originalDate2 = new Date(customDate[1]);

    var year2 = originalDate2.getFullYear();
    var month2 = (originalDate2.getMonth() + 1).toString().padStart(2, "0");
    var day2 = originalDate2.getDate().toString().padStart(2, "0");

    var dateto = year2 + "-" + month2 + "-" + day2;

    let dateval =
      activeDate.value === "Custom"
        ? { from: datefrom, to: dateto }
        : getDateByName(activeDate.value);

    return enqueue(
      "ServerPerformanceTable",
      2,
      async (signal) => {
        try {
          const response = await postDataAPI(
            {
              dateFilter: dateval,
              serviceName: POST_KPI_DASHBOARD.serviceName,
              op: POST_KPI_DASHBOARD.server_performance_op,
              server_id: server_id,
              mealPeriod: mealPeriod,
              page: selectedPage,
              limit: itemsPerPage,
              recalculate: recalculate,
              sort_column: value,
              sort_type: sorttypefinalvalue,
            },
            signal
          );

          if (signal.aborted) return;

          if (response.status === "ok") {
            setServerPerformances(response.data.data);
            setPageCount(
              Math.ceil(response.data.totalData / itemsPerPage)
            );
          } else {
            console.log(response);
            setPageCount(0);
          }
        } catch (e) {
          return;
        } finally {
          if (!signal.aborted) setServerPerformanceAjax(false);
        }
      }
    );
  };

  const serverRows = useMemo(
    () =>
      (serverPerformances || []).filter(
        (item) => item.name !== "Team"
      ),
    [serverPerformances]
  );

  const getServerKey = (item) =>
    item.server_id ?? item.id ?? item.user_id ?? item.name;

  useEffect(() => {
    setSelectedServers((prev) => {
      const currentKeys = serverRows.map(getServerKey);

      if (prev.length === 0 && currentKeys.length > 0) {
        return currentKeys;
      }

      const existingKeys = prev.filter((key) =>
        currentKeys.includes(key)
      );

      const newKeys = currentKeys.filter(
        (key) => !prev.includes(key)
      );

      return [...existingKeys, ...newKeys];
    });
  }, [serverRows]);

  const selectedServerRows = useMemo(
    () =>
      serverRows.filter((item) =>
        selectedServers.includes(getServerKey(item))
      ),
    [serverRows, selectedServers]
  );

  const teamTotals = useMemo(
    () =>
      selectedServerRows.reduce(
        (totals, item) => ({
          covers: totals.covers + Number(item.covers || 0),
          checkCount: totals.checkCount + Number(item.check_count || 0),
          revenue: totals.revenue + Number(item.revenue || 0),
        }),
        { covers: 0, checkCount: 0, revenue: 0 }
      ),
    [selectedServerRows]
  );

  const teamAvgCheck =
    teamTotals.covers > 0 ? teamTotals.revenue / teamTotals.covers : 0;

  const teamRow = useMemo(() => {

    const totalLostOpportunity = selectedServerRows.reduce(
      (total, item) => {
        const covers = Number(item.covers || 0);
        const checkCount = Number(item.check_count || 0);
        const revenue = Number(item.revenue || 0);

        let avgCheck = 0;

        if (covers > 0 && checkCount) {
          avgCheck = revenue / covers;
        }

        const vsTeamAvg = avgCheck - teamAvgCheck;

        return vsTeamAvg < 0
          ? total + covers * Number(vsTeamAvg.toFixed(2))
          : total;
      },
      0
    );

    return {
      name: "Team",
      check_count: teamTotals.checkCount,
      covers: teamTotals.covers,
      revenue: Math.round(teamTotals.revenue),
      avgCheck: Number(teamAvgCheck.toFixed(2)),
      teamAvg: 0,
      cover_percentage:
        teamTotals.covers > 0
          ? Math.round((teamTotals.covers / teamTotals.covers) * 100)
          : 0,
      check_percentage:
        teamTotals.checkCount > 0
          ? Math.round((teamTotals.checkCount / teamTotals.checkCount) * 100)
          : 0,
      revenue_percentage:
        teamTotals.revenue > 0
          ? Math.round((teamTotals.revenue / teamTotals.revenue) * 100)
          : 0,
      aci:
        teamAvgCheck > 0
          ? Number((teamAvgCheck / teamAvgCheck).toFixed(2))
          : 0,
      lost_opportunity: Math.round(totalLostOpportunity),
    };
  }, [selectedServerRows, teamAvgCheck, teamTotals]);

  const serverRowsWithMetrics = useMemo(
    () =>
      serverRows.map((item) => {

        const covers = Number(item.covers || 0);
        const checkCount = Number(item.check_count || 0);
        const revenue = Number(item.revenue || 0);
        const avgCheck =
          covers > 0 && checkCount > 0 ? revenue / covers : 0;
        const teamAvg = avgCheck - teamAvgCheck;

        return {
          ...item,
          avgCheck: Number(avgCheck.toFixed(2)),
          teamAvg: Number(teamAvg.toFixed(2)),
          cover_percentage:
            teamTotals.covers > 0
              ? Math.round((covers / teamTotals.covers) * 100)
              : 0,
          check_percentage:
            teamTotals.checkCount > 0
              ? Math.round((checkCount / teamTotals.checkCount) * 100)
              : 0,
          revenue_percentage:
            teamTotals.revenue > 0
              ? Math.round((revenue / teamTotals.revenue) * 100)
              : 0,
          aci:
            teamAvgCheck > 0
              ? Number((avgCheck / teamAvgCheck).toFixed(2))
              : 0,
          lost_opportunity:
            teamAvg < 0
              ? Number((covers * Number(teamAvg.toFixed(2))).toFixed(2))
              : 0,
        };
      }),
    [serverRows, teamAvgCheck, teamTotals]
  );

  const allServersSelected =
    serverRows.length > 0 &&
    serverRows.every((item) =>
      selectedServers.includes(getServerKey(item))
    );

  const someServersSelected =
    serverRows.some((item) =>
      selectedServers.includes(getServerKey(item))
    ) && !allServersSelected;

  const handleServerSelection = (item) => {
    const key = getServerKey(item);

    setSelectedServers((prev) =>
      prev.includes(key)
        ? prev.filter((selectedKey) => selectedKey !== key)
        : [...prev, key]
    );
  };

  const handleSelectAllServers = (checked) => {
    if (checked) {
      setSelectedServers(serverRows.map(getServerKey));
    } else {
      setSelectedServers([]);
    }
  };

  const handleExport = (e) => {
    var originalDate = new Date(customDate[0]);

    var year = originalDate.getFullYear();
    var month = (originalDate.getMonth() + 1).toString().padStart(2, "0");
    var day = originalDate.getDate().toString().padStart(2, "0");

    var datefrom = year + "-" + month + "-" + day;

    var originalDate2 = new Date(customDate[1]);

    var year2 = originalDate2.getFullYear();
    var month2 = (originalDate2.getMonth() + 1).toString().padStart(2, "0");
    var day2 = originalDate2.getDate().toString().padStart(2, "0");

    var dateto = year2 + "-" + month2 + "-" + day2;

    let dateval =
      activeDate.value === "Custom"
        ? { from: datefrom, to: dateto }
        : getDateByName(activeDate.value);

    const selectedServerIds = serverRows
      .filter((item) => selectedServers.includes(getServerKey(item)))
      .map((item) => item.server_id ?? item.id ?? item.user_id)
      .filter((id) => id != null);
    console.log("serves ids", selectedServerIds);

    const controller = new AbortController();

    postDataAPI(
      {
        dateFilter: dateval,
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: POST_KPI_DASHBOARD.server_performance_op,
        server_id: selectedServerIds,
        mealPeriod: mealPeriod,
        page: selectedPage,
        limit: itemsPerPage,
        recalculate: recalculate,
        sort_column: "",
        sort_type: "",
        export: 1,
        exportColumns: showColumns,
      },
      controller.signal
    ).then((response) => {
      setServerPerformanceAjax(false);

      if (response.status === "ok") {
        window.open(response.data.data.filename);
      } else {
        console.log(response);
      }
    });

    return () => {
      controller.abort();
    };
  };

  const filteredColumns = useMemo(
    () => columnDef.filter((column) => showColumns.includes(column.key)),
    [showColumns, columnDef]
  );

  return (
    <React.Fragment>
      <Card>
        <CardHeader className="align-items-center d-flex spheader">
          <div className="d-flex align-items-start flex-grow-1">
            <div className={`icon-box rounded bg-danger text-white`}>
              <i className="ri-bar-chart-fill"></i>
            </div>

            <div className="ps-2">
              <h4 className="card-title mb-1">
                Server Performance
              </h4>

              <p className="text-muted mb-0">
                Team and individual server results with checks, covers,
                revenue, average check, and lost opportunity.
              </p>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="d-flex ct_top_margin">
              <Dropdown
                isOpen={isOpen}
                toggle={toggleDropdown}
                className="ms-3 ct_left_margin_zero"
                style={{ borderRadius: "0.25rem" }}
              >
                <ButtonGroup>
                  <Button color="info">Columns</Button>

                  <DropdownToggle
                    tag="button"
                    className="btn btn-info"
                    split
                  ></DropdownToggle>
                </ButtonGroup>

                <DropdownMenu className="dropdown-menu-end" end={true}>
                  <div ref={columnDropdownRef}>
                    {columnDef.map((column) => (
                      <DropdownItem
                        onClick={(event) => {
                          handleColumnHideShow(event, column.key);
                        }}
                        key={column.key}
                      >
                        <div className="form-check mb-1">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            id={`column${column.key}`}
                            checked={showColumns.includes(column.key)}
                            value={column.key}
                            readOnly
                          />

                          <Label
                            className="form-check-label"
                            for="formCheck6"
                          >
                            {column.name}
                          </Label>
                        </div>
                      </DropdownItem>
                    ))}
                  </div>
                </DropdownMenu>
              </Dropdown>

              {showGraph && (
                <Button
                  className="ms-3"
                  color="primary"
                  onClick={() => setShowDetailsModal(true)}
                >
                  Details
                </Button>
              )}

              <Button
                className="ms-3"
                color="primary"
                onClick={handleExport}
              >
                Export
              </Button>
            </div>
          </div>
        </CardHeader>

        <CardBody>
          {serverPerformanceAjax && <Loader />}

          <div
            id="ServerPerformance"
            className={
              serverPerformanceAjax
                ? "opacity-0 table-responsive table-card"
                : "table-responsive table-card"
            }
            style={{ maxHeight: "500px", overflow: "auto" }}
          >
            <table className="table table-borderless table-centered align-middle table-nowrap mb-0 text-center">
              <thead className="text-muted table-light">
                <tr
                  style={{
                    position: "sticky",
                    top: "-2px",
                    zIndex: 100,
                  }}
                >
                  <th>
                    <Input
                      type="checkbox"
                      checked={allServersSelected}
                      onChange={(e) =>
                        handleSelectAllServers(e.target.checked)
                      }
                      innerRef={(element) => {
                        if (element) {
                          element.indeterminate = someServersSelected;
                        }
                      }}
                    />
                  </th>

                  {filteredColumns.map(
                    (column) =>
                      showColumns.includes(column.key) && (
                        <th
                          className={column.className}
                          key={column.key}
                          scope="col"
                        >
                          {column.name}{" "}

                          {column.sort && (
                            <i
                              className="las la-arrow-down"
                              style={{
                                cursor: "pointer",
                                transform:
                                  sortColumn == column.key &&
                                  sorttypefinalvalue == "DESC"
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                              }}
                              onClick={() =>
                                handleSort(column.key, "sortcall")
                              }
                            ></i>
                          )}
                        </th>
                      )
                  )}
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td></td>

                  {showColumns.includes("name") && (
                    <td className="text-start">{teamRow.name}</td>
                  )}

                  {showColumns.includes("check_count") && (
                    <td>{numberFormat(teamRow.check_count)}</td>
                  )}

                  {showColumns.includes("covers") && (
                    <td>{numberFormat(teamRow.covers)}</td>
                  )}

                  {showColumns.includes("revenue") && (
                    <td>
                      {currencyFormatWithoutDecimal(teamRow.revenue, currency)}
                    </td>
                  )}

                  {showColumns.includes("avgCheck") && (
                    <td>{currencyFormatWithAlert(teamRow.avgCheck, currency)}</td>
                  )}

                  {showColumns.includes("teamAvg") && (
                    <td>{currencyFormatWithAlert(teamRow.teamAvg, currency)}</td>
                  )}

                  {showColumns.includes("cover_percentage") && (
                    <td>{numberFormat(teamRow.cover_percentage)}</td>
                  )}

                  {showColumns.includes("check_percentage") && (
                    <td>{numberFormat(teamRow.check_percentage)}</td>
                  )}

                  {showColumns.includes("revenue_percentage") && (
                    <td>{numberFormat(teamRow.revenue_percentage)}</td>
                  )}

                  {showColumns.includes("aci") && (
                    <td>{numberFormat(teamRow.aci)}</td>
                  )}

                  {showColumns.includes("lost_opportunity") && (
                    <td>
                      {currencyFormatWithAlert(teamRow.lost_opportunity, currency)}
                    </td>
                  )}
                </tr>

                {serverRowsWithMetrics.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <Input
                        type="checkbox"
                        checked={selectedServers.includes(
                          getServerKey(item)
                        )}
                        onChange={() => handleServerSelection(item)}
                      />
                    </td>

                    {showColumns.includes("name") && (
                      <td className="text-start">
                        {item.name}
                      </td>
                    )}

                    {showColumns.includes("check_count") && (
                      <td>
                        {numberFormat(item.check_count)}
                      </td>
                    )}

                    {showColumns.includes("covers") && (
                      <td>
                        {numberFormat(item.covers)}
                      </td>
                    )}

                    {showColumns.includes("revenue") && (
                      <td>
                        {currencyFormatWithoutDecimal(
                          item.revenue,
                          currency
                        )}
                      </td>
                    )}

                    {showColumns.includes("avgCheck") && (
                      <td>
                        {currencyFormatWithAlert(
                          item.avgCheck,
                          currency
                        )}
                      </td>
                    )}

                    {showColumns.includes("teamAvg") && (
                      <td>
                        {currencyFormatWithAlert(
                          item.teamAvg,
                          currency
                        )}
                      </td>
                    )}

                    {showColumns.includes("cover_percentage") && (
                      <td>
                        {numberFormat(item.cover_percentage)}
                      </td>
                    )}

                    {showColumns.includes("check_percentage") && (
                      <td>
                        {numberFormat(item.check_percentage)}
                      </td>
                    )}

                    {showColumns.includes("revenue_percentage") && (
                      <td>
                        {numberFormat(item.revenue_percentage)}
                      </td>
                    )}

                    {showColumns.includes("aci") && (
                      <td>
                        {numberFormat(item.aci)}
                      </td>
                    )}

                    {showColumns.includes("lost_opportunity") && (
                      <td>
                        {currencyFormatWithAlert(
                          item.lost_opportunity,
                          currency
                        )}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4 float-end">
            <nav>
              <CustomPagination
                pageCount={pageCount}
                setSelectedPage={setSelectedPage}
              />
            </nav>
          </div>
        </CardBody>
      </Card>

      {showGraph && showDetailsModal && (
        <ServerModal
          mealPeriod={mealPeriod}
          server_id={""}
          activeDate={activeDate}
          customDate={customDate}
          selectedPage={selectedPage}
          showDetailsModal={showDetailsModal}
          setShowDetailsModal={setShowDetailsModal}
          selectedPageST={selectedPageST}
          setSelectedPageST={setSelectedPageST}
          currency={currency}
        />
      )}
    </React.Fragment>
  );
};

export default ServerPerformance;